import SchoolInformation from "./01.SchoolInformation";
import TimingInformation from "./02.TimingInformation";

const Components = {
  SchoolInformation,
  TimingInformation,
};

export default Components;
